import styled from 'styled-components';
import { withOmitProps } from '../helpers/elements';
import { isDefined } from '../helpers/defined';
import { baseHighlightStyle } from '../tokens/highlight';
import { svgColorStyle, svgDisplayStyle, svgKeys, svgPointerStyle, svgSizeStyle } from './style';
import { lineHeight } from '../style/line-height';

// Component to be used as a wrapper for SVG element
// e.g. <SvgIcon size={24} color={'#000'}><LocationIcon /></SvgIcon>
const SvgIcon = styled.span.withConfig(withOmitProps(svgKeys))`
  ${baseHighlightStyle}
  ${svgDisplayStyle}
  ${svgSizeStyle}
  ${svgPointerStyle}
  
  ${/* re-writing line-height for parent wrapper */''}
  ${({
  size
}) => isDefined(size) && lineHeight(size)}
  ${({
  height
}) => isDefined(height) && lineHeight(height)}
  
  svg {
    ${svgSizeStyle}
    ${svgColorStyle}
  }
`;
export default SvgIcon;